import React from 'react';

import ColorControl from 'components/Toolbar/Shared/Color';
import { colorTints } from 'const';
import { brandColorsAreEqual } from 'models';
import { colorWithTint } from 'utils/converters';
import { ColorTintsProps } from './models';
import styles from './styles.module.scss';

const ColorTints: React.FunctionComponent<ColorTintsProps> = (props) => {
  const { activeColor, color, toggleColor, toggleTooltip, dataTestId = 'colorTints' } = props;
  const tintedColors = colorTints.map((tint, index) => ({
    key: index.toString(),
    tintedColor: colorWithTint(color, tint),
  }));

  return (
    <div className={styles.ColorTints} data-testid={dataTestId}>
      <div className={styles.controls} data-testid={`${dataTestId}-controls`}>
        {color && tintedColors.map(({ tintedColor, key }) => (
          <ColorControl
            key={key}
            color={tintedColor}
            isActive={!!activeColor && brandColorsAreEqual(tintedColor, activeColor)}
            onToggle={toggleColor}
            toggleTooltip={toggleTooltip}
            dataTestId={`${dataTestId}-color-${key}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorTints;
